import { render, staticRenderFns } from "./move-portfolio-modal.vue?vue&type=template&id=ac6692fa&scoped=true&"
import script from "./move-portfolio-modal.vue?vue&type=script&lang=js&"
export * from "./move-portfolio-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6692fa",
  null
  
)

export default component.exports